import { Organization } from '@marmon/shared/types/organization';
import { Group } from '../interfaces';

export const MaxGroupLeaders = 10;

export function assignedOrganizationIds(
	groups: Pick<Group, 'organizations'>[],
): Set<string> {
	const assigned = new Set<string>();
	for (const group of groups) {
		for (const ref of group.organizations ?? []) {
			if (ref?.id) assigned.add(ref.id);
		}
	}
	return assigned;
}

export function availableOrganizations<T extends Pick<Organization, 'id'>>(
	organizations: T[],
	groups: Pick<Group, 'organizations'>[],
	selectedIds: Iterable<string> = [],
): T[] {
	const assigned = assignedOrganizationIds(groups);
	const selected = new Set(Array.from(selectedIds).filter(Boolean));

	return organizations.filter(
		(organization) =>
			!assigned.has(organization.id) && !selected.has(organization.id),
	);
}
